<template>
  <section class="hero is-fullheight">
    <!-- Hero head: will stick at the top -->
    <div class="hero-head">
      <nav v-on-clickaway="close" :class="['navbar is-fixed-top', {'is-active': isActive}]">
        <div class="container">
          <div class="navbar-brand">
            <a class="navbar-item b-logo" href="https://bringe.com">
              <img src="../assets/logo.png" alt="Logo">
            </a>
            <span @click="toggle" :class="[{'is-active': isActive}, 'navbar-burger burger']"
                  data-target="navbarMenuHeroA">
            <span></span>
            <span></span>
            <span></span>
          </span>
          </div>
          <div id="navbarMenuHeroA" :class="[{'is-active': isActive}, 'navbar-menu']">
            <div class="navbar-end">
              <div class="navbar-end">
                <a class="navbar-item" href="#" @click="popUp = true">
                  <button class="button is-warning is-rounded">COVID-19</button>
                </a>
                <a class="navbar-item" href="#home" @click="close">{{ $t("home") }}</a>
                <a class="navbar-item" href="#services" @click="close">{{ $t("services") }}</a>
                <a class="navbar-item" href="#about" @click="close">{{ $t("about") }}</a>
                <a class="navbar-item" href="#contact" @click="close">{{ $t("contact") }}</a>
                <a class="navbar-item" href="#jobs" @click="close">{{ $t("jobs") }}</a>

                <div class="navbar-item has-dropdown is-hoverable">
                  <a class="navbar-link">
                    <fa icon="language"></fa>
                  </a>

                  <div class="navbar-dropdown">
                    <a class="navbar-item" @click.prevent="lang('de')">
                      Deutsch
                    </a>
                    <a class="navbar-item" @click.prevent="lang('en')">
                      English
                    </a>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>

    <!-- Hero content: will be in the middle -->
    <div class="hero-body has-text-centered" id="particles-js">
      <div class="container">
        <h1 class="title">
          {{$t("title")}}
        </h1>
        <h2 class="subtitle">
          {{$t("subtitle")}}
        </h2>
      </div>
    </div>

    <div :class="[{'is-active': popUp}, 'modal']">
      <div @click="popUp = false" class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">COVID-19</p>
          <button @click="popUp = false" class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          Aus aktuellem Anlass und um die gesundheitlichen Risiken unserer Mitarbeiter auf ein Minimum zu reduzieren, haben wir uns dazu entschlossen, es Allen frei zu stellen, von zu Hause aus arbeiten zu können.
          <strong>Ungeachtet dessen werden wir alle Service-Leistungen in normaler Art und Weise weiter erbringen.</strong> Sie erreichen uns über die bekannten Kommunikationskanäle einschließlich Telefon und E-Mail in gewohnter Art und Weise.
          <br>
          <br>
          Sollten Sie Fragen zu den einzelnen Kommunikationsverfahren, z. B. auch für den Einsatz in Ihrem Unternehmen haben, scheuen Sie sich nicht uns zu kontaktieren.
          <br>
          <br>
          Bleiben Sie gesund!

          <br>
          <br>
          Karlsruhe, den 17.03.2020
        </section>
      </div>
    </div>

    <div :class="[{'is-active': popUp2}, 'modal']">
      <div @click="popUp2 = false" class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Betriebsferien</p>
          <button @click="popUp2 = false" class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          Die Bringe IT geht <strong>vom 24. Dezember 2020 bis zum 6. Januar 2021</strong> in die Betriebsferien.
          <br>
          Während dieser Zeit, erreichen sie unser Bereitschafts-Team wie gewohnt über unsere Hotline und unser Ticketsystem.
          <br>
          Wir wünschen allen unseren Partnern ein Frohes Fest und einen guten Rutsch ins neue Jahr.
          <br>
          <br>
          Bleiben Sie gesund!

          <br>
          <br>
          Karlsruhe, den 23.12.2020
        </section>
      </div>
    </div>


  </section>
</template>

<script>
import { mixin as ClickAway } from 'vue-clickaway';
import 'particles.js';

export default {
  name: 'BHero',
  mixins: [ClickAway],
  mounted() {
    this.initParticles();
  },
  data() {
    return {
      isActive: false,
      popUp: false,
      popUp2: false,
    };
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive;
    },
    close() {
      this.isActive = false;
    },
    lang(locale) {
      this.$i18n.locale = locale;
      this.close();
    },
    initParticles() {
      window.particlesJS("particles-js", {
        "particles": {
          "number": {
            "value": 40,
            "density": {
              "enable": true,
              "value_area": 500
            }
          },
          "color": {
            "value": "#000"
          },
          "shape": {
            "type": "circle",
            "stroke": {
              "width": 0,
              "color": "#000000"
            },
            "polygon": {
              "nb_sides": 5
            },
          },
          "opacity": {
            "value": 0.5,
            "random": false,
            "anim": {
              "enable": false,
              "speed": 1,
              "opacity_min": 0.1,
              "sync": false
            }
          },
          "size": {
            "value": 3,
            "random": true,
            "anim": {
              "enable": false,
              "speed": 40,
              "size_min": 0.1,
              "sync": false
            }
          },
          "line_linked": {
            "enable": true,
            "distance": 150,
            "color": "#000",
            "opacity": 0.4,
            "width": 1
          },
          "move": {
            "enable": true,
            "speed": 2,
            "direction": "none",
            "random": false,
            "straight": false,
            "out_mode": "out",
            "bounce": false,
            "attract": {
              "enable": false,
              "rotateX": 600,
              "rotateY": 1200
            }
          }
        },
        "interactivity": {
          "detect_on": "canvas",
          "events": {
            "onhover": {
              "enable": true,
              "mode": "grab"
            },
            "onclick": {
              "enable": true,
              "mode": "push"
            },
            "resize": true
          },
          "modes": {
            "grab": {
              "distance": 140,
              "line_linked": {
                "opacity": 1
              }
            },
            "bubble": {
              "distance": 400,
              "size": 40,
              "duration": 2,
              "opacity": 8,
              "speed": 3
            },
            "repulse": {
              "distance": 200,
              "duration": 0.4
            },
            "push": {
              "particles_nb": 4
            },
            "remove": {
              "particles_nb": 2
            }
          }
        },
        "retina_detect": true
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "../styles/variables";


  .modal-card-body {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  .hero {
    .hero-body {
      .container {
        padding-left: .25em;
        padding-right: .25em;
        z-index: 20;
        position: absolute;
        right: 0 !important;
        left: 0 !important;
      }
      .title {
        text-transform: uppercase;
        font-weight: normal !important;
      }
    }
    img {
      max-height: 45px !important;
    }
    .navbar {
      background-color: $white;
      border-bottom: thin solid $grey-lighter;
    }
    .navbar-burger,
    .navbar-item {
      color: $blue;
    }
    .navbar-burger:hover,
    .navbar-item:hover {
      color: $orange;
      background-color: transparent;
    }
  }

  .has-dropdown,
  .navbar-dropdown {
    width: 5.5em;
    max-width: 5.5em;
    .navbar-link {
      width: 5.5em;
      max-width: 5.5em;
    }
  }
</style>
